import { useNavigate } from "react-router-dom";

import CryptoAssetButton from "app/components/CryptoAssetButton";
import Page from "app/components/Page";
import { PAYMENT_PAGE, TRANSFER_ROOT } from "app/constants/routes";
import { COIN_IMG_BASE_URL } from "app/constants/variables";
import { AppStateActions, useApp } from "app/providers/AppStateProvider";
import useListCurrencies from "app/views/Busha/TransferConfirm/hooks/useListCurrencies";
import LoaderContainer from "app/components/LoaderContainer";

export default function AssetsSelection() {
  const [{ merchant }, dispatch] = useApp();
  const { currencies, isLoading, error, refetch } = useListCurrencies({
    type: "crypto",
    payments_request: true,
    publicKey: merchant?.public_key,
  });

  const supportedCurrencies = currencies?.filter(
    (c) => c.supported_networks.length > 0
  );

  const navigate = useNavigate();

  return (
    <Page title="Select asset" onBack={() => navigate(-1)}>
      <LoaderContainer
        loading={isLoading}
        error={!!error}
        errorMessage={error!}
        onRetry={refetch}
      >
        <div tw="overflow-y-auto max-h-full w-full">
          <div tw="flex flex-col mt-[4px]">
            {supportedCurrencies?.map(
              ({ name, code, supported_networks }, index) => (
                <CryptoAssetButton
                  noBorder={index >= supportedCurrencies?.length - 1}
                  key={name}
                  name={name}
                  code={code}
                  url={`${COIN_IMG_BASE_URL}/${code}.svg`}
                  onClick={() => {
                    dispatch({
                      type: AppStateActions.setActiveAsset,
                      payload: {
                        name,
                        currency_id: code,
                        chains: supported_networks?.map((n) => n.network),
                        supportedNetworks: supported_networks,
                      },
                    });

                    navigate(`${TRANSFER_ROOT}/${PAYMENT_PAGE}`);
                  }}
                />
              )
            )}
          </div>
        </div>
      </LoaderContainer>
    </Page>
  );
}
